import { fetchAndActivate, getRemoteConfig, getValue } from 'firebase/remote-config';
import firebaseApp from './firebase.init';

let fetchAndActivatePromise: Promise<boolean> | null = null;

export const remoteConfig: any = (() => {
  try {
    if (typeof window === 'undefined') {
      return null;
    }
    const config = getRemoteConfig(firebaseApp);
    config.settings.minimumFetchIntervalMillis = 1500;
    return config;
  } catch (error) {
    return null;
  }
})();

export const getFirebaseConfig = async (key: any) => {
  try {
    if (!fetchAndActivatePromise) {
      fetchAndActivatePromise = fetchAndActivate(remoteConfig);
    }

    await fetchAndActivatePromise;
    return getValue(remoteConfig, key).asString();
  } catch (err) {
    console.error(`Error retrieving key ${key} from Firebase Config:`, err);
    // return firebaseConfigData[key] ?? ''
  }
};
